import { memo } from 'react';

import { IconWebhook } from '@components/icons/webhook';
import { SquareImage } from '@components/square-image';
import { useScopedTranslate } from '@locale/translate';

import { TravellerNodeActionCard } from 'ui/journey-builder/node-types/node-container';
import { NodeActions } from 'ui/traveller-journey-builder/node-types/common';
import { NodeContainer } from 'ui/traveller-journey-builder/node-types/node-container';
import { TravellerJourneyNode } from 'ui/traveller-journey-builder/node-types/types';

type ActionType = 'webhook';

export const Node = memo((node: TravellerJourneyNode<ActionType>) => {
  const { t } = useScopedTranslate(nodeLocale);
  const integration = node.data.integration;

  return (
    <NodeContainer node={node}>
      <TravellerNodeActionCard
        node={node}
        label={integration?.name ?? t('title')}
        descriptionText={node.data.description || t('description')}
        icon={
          integration?.thumbnail ? (
            <SquareImage src={integration.thumbnail} />
          ) : (
            <IconWebhook color="green200" />
          )
        }
      >
        <NodeActions node={node} />
      </TravellerNodeActionCard>
    </NodeContainer>
  );
});

const nodeLocale = {
  en: {
    title: 'Webhook ',
    description: 'Wait for incoming webhook',
  },
};
